export const getPercentageSpendRequirementMet = ({
  spendThreshold,
  basketSubtotal,
}: {
  spendThreshold: number;
  basketSubtotal: number;
}) => {
  return Math.round(Math.min(basketSubtotal / spendThreshold, 1) * 100);
};
